import { render, staticRenderFns } from "./pc-satisfaction.vue?vue&type=template&id=4ec01fdc&scoped=true&"
import script from "./pc-satisfaction.vue?vue&type=script&lang=js&"
export * from "./pc-satisfaction.vue?vue&type=script&lang=js&"
import style0 from "./pc-satisfaction.vue?vue&type=style&index=0&id=4ec01fdc&scoped=true&lang=less&"
import style1 from "./pc-satisfaction.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec01fdc",
  null
  
)

export default component.exports